export default "__VITE_ASSET__CjFQyQST__"